import { useEffect, useState } from "react";
import { User } from "./UserAccountList";
import { Select } from "antd";
import { API_URL } from "env";

const AccountEditModal = ({ account, onClose }: { account: string; onClose: () => void }) => {
    const [listUser, setListUser] = useState<User[] | null>(null);
    const [accountDetail, setAccountDetail] = useState<{
        id: string;
        user_id: string;
        account_number: string;
        nickname: string;
        platform: string;
        broker: string;
    } | null>(null);
    const [seletedUser, setSelectedUser] = useState<string | null>(null);
    async function fetchAccountDetails() {
        try {
            const response = await fetch(`${API_URL}api/v1/be/trade_account/${account}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (!response.ok) {
                console.error('Failed to fetch account details:', response.statusText);
            }
            const data = await response.json();
            setAccountDetail({
                id: data.data.id,
                user_id: data.data.user_id,
                account_number: data.data.account_number,
                nickname: data.data.nickname,
                platform: data.data.platform,
                broker: data.data.broker
            });
            setSelectedUser(data.data.user_id);
        } catch (error) {
            console.error('Error fetching account details:', error);
        }
    }
    async function fetchListUser() {
        try {
            const response = await fetch(`${API_URL}api/v1/be/users`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (!response.ok) {
                console.error('Failed to fetch account details:', response.statusText);
            }
            const data = await response.json();
            const users: User[] = data.data.items.map((item: any) => ({
                id: item.id,
                name: item.name,
                avatar_url: item.avatar_url || '',
                email: item.email,
            }));
            setListUser(users);
        } catch (error) {
            console.error('Error fetching account details:', error);
            return null;
        }
    }
    const handleSaveChanges = async () => {
        
        try {
            if (seletedUser == null || seletedUser === '') {
                const response = await fetch(`${API_URL}api/v1/be/trade_account/${account}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify({ user_id: null })
                });
                if (!response.ok) {
                    console.error('Failed to update account:', response.statusText);
                    return;
                }

            }
            else {
                const response = await fetch(`${API_URL}api/v1/be/trade_account/${account}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify({ user_id: seletedUser })
                });
                if (!response.ok) {
                    console.error('Failed to update account:', response.statusText);
                    return;
                }
            }

            onClose();
        } catch (error) {
            console.error('Error updating account:', error);
        }
    };
    useEffect(() => {
        fetchListUser();
        fetchAccountDetails();
    }, []);
    return (
        <div>
            {accountDetail && (
                <div className="mb-4 grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium mb-2">Account Number</label>
                        <p className="mt-1 border border-gray-300 rounded-md py-2 px-4">{accountDetail.account_number}</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-2">Nickname</label>
                        <p className="mt-1 border border-gray-300 rounded-md py-2 px-4">{accountDetail.nickname}</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-2">Platform</label>
                        <p className="mt-1 border border-gray-300 rounded-md py-2 px-4">{accountDetail.platform}</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-2">Broker</label>
                        <p className="mt-1 border border-gray-300 rounded-md py-2 px-4">{accountDetail.broker}</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-2">Account ID</label>
                        <p className="mt-1 border border-gray-300 rounded-md py-2 px-4">{accountDetail.id || "Unassigned"}</p>
                    </div>
                </div>
            )}
            {
                accountDetail && listUser && (
                    <div className="mb-4">

                        <label className="block flex flex-col  mb-2">
                            <span className="">Assign User</span>
                            <Select
                                showSearch
                                allowClear
                                size="large"
                                style={{ width: "100%" }}
                                placeholder="Search to Select"
                                optionFilterProp="label"
                                options={[
                                    { value: '', label: 'Unassign User' },
                                    ...listUser.map(user => ({
                                        value: user.id,
                                        label: `${user.name || ""} ${user.email}`,
                                    }))
                                ]}
                                value={seletedUser}
                                onChange={(value) => {
                                    setSelectedUser(value);
                                    setAccountDetail(prev => prev ? { ...prev, user_id: value } : null);
                                }}
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500"
                            />
                        </label>
                        <button
                            onClick={() => {
                                handleSaveChanges();
                            }}
                            className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                        >
                            Save Changes
                        </button>
                    </div>
                )
            }
        </div>
    )
}
export default AccountEditModal;